import { render, staticRenderFns } from "./AppBrands.vue?vue&type=template&id=1fd4e09b&scoped=true&"
import script from "./AppBrands.vue?vue&type=script&lang=js&"
export * from "./AppBrands.vue?vue&type=script&lang=js&"
import style0 from "./AppBrands.vue?vue&type=style&index=0&id=1fd4e09b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4e09b",
  null
  
)

export default component.exports